define('services/auth/handler',['require','exports','module','base/region','common/views/message_view'],function(require, exports, module) {
  "use strict";

  var Region = require("base/region"),
    MessageView = require("common/views/message_view");

  module.exports = function(config) {
    return {
      handle: function(status) {
        if (status === 401) { // login redirect
          window.location.href = config.loginUrl;
        } else if (status === 403 || status === 500) { // forbidden
          var bodyRegion = new Region({
            $el: $("body")
          });
          bodyRegion.showInstance(MessageView, {
            title: "message." + status + ".title",
            content: "message." + status + ".content"
          });
        }
      }
    };
  };

});

